const colors = {
  white: "#ffffff",
  black: "#000000",
  background: "#fCFDFD",
  teal50: "#E6FCF5",
  teal100: "#C3FAE8",
  teal200: "#96F2D7",
  teal300: "#63E6BE",
  teal400: "#38D9A9",
  teal500: "#20C997",
  teal600: "#12B886",
  teal700: "#0CA678",
  teal800: "#099268",
  teal900: "#087F5B",
  grey50: "#F8F9FA",
  grey100: "#F1F3F5",
  grey200: "#E9ECEF",
  grey300: "#DEE2E6",
  grey400: "#CED4DA",
  grey500: "#ADB5BD",
  grey600: "#868E96",
  grey700: "#495057",
  grey800: "#343A40",
  grey900: "#212529",
};

const theme = {
  colors,
};

export default theme;
